// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import * as Sentry from '@sentry/react';
import { File } from '@/file/api/types';

/**
 * Returns the download URL for the given file.
 *
 * @param file - The file for which to generate a download URL.
 */
export function getDownloadURL(file: File) {
  try {
    const downloadURL = new URL(file.url);

    downloadURL.searchParams.set('attachment', 'true');

    return downloadURL;
  } catch (error) {
    Sentry.captureException(error);
  }

  return null;
}

/**
 * This gets a qualified file URL based on a file key provided, returns string or undefined
 * @param fileKey
 */
export function getFileURL(fileKey: string | null) {
  if (fileKey === null) {
    return undefined;
  }
  return `${import.meta.env.VITE_API_URL}/v1/file/${fileKey}`;
}

/**
 * Takes null or a file key and returns a path to include it as an image.
 * If there's no image, it returns a transparent empty image.
 * @param fileKey - the key identifier for the file
 */
export function getFileImageURLForFileKey(fileKey: string | null): string {
  if (fileKey === null) {
    // Blank image return
    return 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
  }
  return `${import.meta.env.VITE_API_URL}/v1/file/${fileKey}`;
}
